import { createFeatureSelector } from '@ngrx/store';
import { INotificationsState } from '@stores/notifications.reducer';

export const selectNotifications =
  createFeatureSelector<INotificationsState>('notifications');
